import React from "react";
import { Breadcrumb } from "semantic-ui-react";
// import _ from "lodash";

export const getMySearchesBreadcrumb = (props) => (
  <Breadcrumb>
    <Breadcrumb.Section link>
      <span
        role="menu"
        tabIndex={-1}
        style={{ cursor: "pointer", color: "#4183c4" }}
        onClick={() => props.history.push(encodeURI(`/My Account/My Searches`))}
      >
        {`My Account`}
      </span>
    </Breadcrumb.Section>
    <Breadcrumb.Divider />
    <Breadcrumb.Section active>{props.currentPage}</Breadcrumb.Section>
  </Breadcrumb>
);

export default getMySearchesBreadcrumb;

// {
//   const arrBreadcrumbs = [];
//   _.forEach(props.breadcrumbs, (breadcrumb, index) => {
//     if (index > 0) {
//       arrBreadcrumbs.push(<Breadcrumb.Divider key={`bread_div_${index}`} />);
//     }
//     arrBreadcrumbs.push(
//       <Breadcrumb.Section
//         active={breadcrumb.isActive}
//         link={!breadcrumb.isActive}
//         key={`bread_sec_${index}`}
//       >
//         <span
//           role="menu"
//           tabIndex={-1}
//           style={{ cursor: "pointer", color: "#4183c4" }}
//           onClick={() =>
//             !breadcrumb.isActive && this.props.history.push(breadcrumb.url)
//           }
//         >
//           {breadcrumb.text}
//         </span>
//       </Breadcrumb.Section>
//     );
//   });
//   return <Breadcrumb>{arrBreadcrumbs}</Breadcrumb>;
// };



// WEBPACK FOOTER //
// ./src/components/common/Breadcrumb.js